import React, { useMemo } from "react";

import { Theme, useTheme } from "@mui/material/styles";

import {
  FullWidthTextField,
  SingleItemRowContainer,
  logDebug,
  mergeProperties,
  packableDeepClone,
} from "packable-components";
import {
  OrderItemAction,
  OrderUserCancelActionsProps,
  ShippingStatus,
} from "./Order.types";
import { Button, Grid } from "@mui/material";

const getStyles = (theme: Theme) => ({
  OrderActionContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  OrderUserCancelActionButtonUnselected: {
    muiColor: "secondary",
    muiVariant: "outlined",
    width: "240px",
  },
  OrderUserCancelActionButtonSelected: {
    muiColor: "secondary",
    muiVariant: "contained",
    width: "240px",
  },
  OrderUserCancelActionButtonContainer: {
    pb: 1,
  },
  OrderActionContentFullWidthTextFieldContainer: {
    width: "100%",
  },
});

export const OrderUserCancelAction: React.FC<OrderUserCancelActionsProps> = (
  props
): React.JSX.Element => {
  const { originalStatus, itemLabel, orderItemAction, onOrderItemActionUpdate, disabled = false, styles } =
    props;

  logDebug("OrderUserCancelAction PROPS");
  logDebug(props);

  const theme = useTheme();

  const defaultStyles = useMemo(() => getStyles(theme), [theme]);
  const effectiveStyles = useMemo(
    () =>
      styles === undefined
        ? defaultStyles
        : mergeProperties(defaultStyles, styles),
    [defaultStyles, styles]
  );

  logDebug("OrderUserCancelAction effectiveStyles");
  logDebug(effectiveStyles);

  const handleNoteValueChange = (event: any) => {
    let newOrderItemAction = packableDeepClone(orderItemAction);
    newOrderItemAction.note = event.target.value;
    onOrderItemActionUpdate(newOrderItemAction);
  };

  const handleCancelClick = (event: React.MouseEvent<HTMLElement>) => {
    let newOrderItemAction: OrderItemAction = packableDeepClone(orderItemAction);
    if (newOrderItemAction.shippingStatus === ShippingStatus.CANCEL_REQUESTED) {
      newOrderItemAction.shippingStatus = originalStatus;
    } else {
      newOrderItemAction.shippingStatus = ShippingStatus.CANCEL_REQUESTED;
    }
    onOrderItemActionUpdate(newOrderItemAction);
  };

  return (
    <>
      <Grid 
        className="OrderActionContainer"
        sx={effectiveStyles.OrderActionContainer}
    >
        <SingleItemRowContainer
          styles={{ PackableSingleItemRowContainer: { padding: 1 } }}
        >
          <Grid
            className="OrderUserCancelActionButtonContainer"
            sx={effectiveStyles.OrderUserCancelActionButtonContainer}
          >
            <Button
              className={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? "OrderUserCancelActionButtonSelected"
                  : "OrderUserCancelActionButtonUnselected"
              }
              sx={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? effectiveStyles.OrderUserCancelActionButtonSelected
                  : effectiveStyles.OrderUserCancelActionButtonUnselected
              }
              disabled={disabled}
              onClick={handleCancelClick}
              variant={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? effectiveStyles.OrderUserCancelActionButtonSelected
                      .muiVariant
                  : effectiveStyles.OrderUserCancelActionButtonUnselected
                      .muiVariant
              }
              color={
                orderItemAction.shippingStatus ===
                ShippingStatus.CANCEL_REQUESTED
                  ? effectiveStyles.OrderUserCancelActionButtonSelected.muiColor
                  : effectiveStyles.OrderUserCancelActionButtonUnselected
                      .muiColor
              }
            >
              {orderItemAction.shippingStatus ===
              ShippingStatus.CANCEL_REQUESTED
                ? `Undo Cancel Storage ${itemLabel}`
                : `Cancel Storage ${itemLabel}`}
            </Button>
          </Grid>
        </SingleItemRowContainer>
        {orderItemAction.shippingStatus ===
          ShippingStatus.CANCEL_REQUESTED && (
          <SingleItemRowContainer
            styles={{ PackableSingleItemRowContainer: { padding: 1 } }}
          >
            <Grid
              className="OrderActionContentFullWidthTextFieldContainer"
              sx={effectiveStyles.OrderActionContentFullWidthTextFieldContainer}
            >
              <FullWidthTextField
                id="note"
                label="Note"
                value={orderItemAction.note}
                onChange={handleNoteValueChange}
              />
            </Grid>
          </SingleItemRowContainer>
        )}
      </Grid>
    </>
  );
};

export default OrderUserCancelAction;
